<template>
  <VaLayout
    :top="{ fixed: true, order: 2 }"
    :left="{ fixed: true, absolute: breakpoints.mdDown, order: 1, overlay: breakpoints.mdDown && !isSidebarMinimized }"
    @leftOverlayClick="isSidebarMinimized = true"
  >
    <template #top>
      <EducationNavbar :is-mobile="isMobile" />
    </template>
    <template #left>
      <EducationSidebar v-if="isMobile" :minimized="isSidebarMinimized" :mobile="isMobile" />
    </template>
    <template #content>
      <main class="pt-0">
        <article class="min-h-[100vh] bg-[#ffffff]">
          <RouterView />
        </article>
      </main>
    </template>
    <template #bottom>
      <AppBottomNavbar
        :is-mobile="isMobile"
        site="education"
        copyright="©2026 深圳市拓寰联宸商务咨询有限公司"
        abn="统一社会信用代码 91440300MAKNDGCF8L"
      />
    </template>
  </VaLayout>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { onBeforeRouteUpdate } from 'vue-router'
import { useBreakpoint } from 'vuestic-ui'
import { useGlobalStore } from '../stores/global-store'
import EducationNavbar from '../components/navbar/EducationNavbar.vue'
import EducationSidebar from '../components/sidebar/EducationSidebar.vue'
import AppBottomNavbar from '../components/bottombar/AppBottomNavbar.vue'

const GlobalStore = useGlobalStore()
const breakpoints = useBreakpoint()

const isMobile = ref(false)
const isTablet = ref(false)
const { isSidebarMinimized } = storeToRefs(GlobalStore)

const onResize = () => {
  isSidebarMinimized.value = breakpoints.mdDown
  isMobile.value = breakpoints.smDown
  isTablet.value = breakpoints.mdDown
}

onMounted(() => {
  window.addEventListener('resize', onResize)
  onResize()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

onBeforeRouteUpdate(() => {
  if (breakpoints.mdDown) {
    isSidebarMinimized.value = true
  }
})
</script>

<style lang="scss" scoped>
.va-sidebar {
  width: unset !important;
  min-width: unset !important;
}
</style>
